<script>
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";
import useTools from "@/use/Tools";
import {useEvaluationPerformanceStore} from "@/stores/Evaluation/EvalautionPerformance";
import {onMounted, ref} from "vue";

export default {
    setup() {
        const {$route} = useTools();
        const {getBack, formatedDate} = useSharedMethod();
        const {dialog, loading} = useSharedData();

        const evaluationPerformance = ref({});

        const evaluationPerformanceStore = useEvaluationPerformanceStore();

        function findById(id) {
            loading.value = true;
            axios.get(`/evaluationPerformances/${id}`).then((response) => {
                evaluationPerformance.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function launch() {
            loading.value = true;
            axios.put(`/evaluationPerformances/close/${$route.params.id}`).then((response) => {
                evaluationPerformanceStore.updateEvaluationPerformance(response.data);
                getBack();
            }).finally(() => {
                loading.value = false;
            });
        }

        onMounted(() => findById($route.params.id));

        return {
            dialog,
            loading,
            evaluationPerformance,
            getBack,
            launch,
            formatedDate,
        }
    }
}
</script>

<template>
    <div>
        <v-dialog
            v-model="dialog"
            persistent
            scrollable
            max-width="600"
        >
            <v-card>
                <w-toolbar :title="`Lancement de la campagne d’évaluation`" color="cyan"/>
                <v-card-text>
                    <v-container fluid>
                        <p>
                            <strong>
                                Campagne : {{ evaluationPerformance.name }}
                            </strong>
                        </p>
                        <p>
                            <strong>Période d’évaluation</strong> : Du <span class="teal--text">{{ formatedDate(evaluationPerformance.cycleStart) }}</span> au <span class="red--text">{{ formatedDate(evaluationPerformance.cycleEnd) }}</span>
                        </p>
                        <p>
                            <strong>Information:</strong>
                        </p>
                        <p>
                            Vous êtes sur le point de lancer la campagne d’évaluation <strong>« {{ evaluationPerformance.name }} »</strong>.

                            Une notification par e-mail sera automatiquement envoyée à l’ensemble des collaborateurs concernés afin de les informer de l’ouverture de la campagne.

                            Souhaitez-vous confirmer le lancement de cette campagne ?
                        </p>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="getBack"/>
                    <w-btn
                        icon="mdi-clock-start"
                        :text="'Confirmer le lancement'"
                        color="cyan"
                        :loading="loading"
                        @press="launch"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<style scoped>

</style>